import { createAsyncThunk } from '@reduxjs/toolkit'
import DataService from "../service";
import { constant } from '../constant'
const { path } = constant;
export const fetchAuditTrailList = createAsyncThunk(
    'auditTrail/fetchWard',
    (arg, { rejectWithValue }) => DataService.get(arg,  path+'client/account/v1/all-bed-audit', rejectWithValue)
)


export const getAuditTrailByBedId = createAsyncThunk(
    'auditTrail/getAuditTrailByBedId',
    (arg, { rejectWithValue }) => DataService.get(arg, path+`client/account/v1/single-bed-audit/{bedId}/${arg?.bedId}`, rejectWithValue)
)